import React from 'react';

const Resources = () => {
  return (
    <div>
      <h2>Resources</h2>
      <ul>
        <li>
          <a href="https://twitter.com/dkundel">@dkundel</a>
        </li>
        <li>
          <a href="https://github.com/dkundel">github.com/dkundel</a>
        </li>
        <li>
          <a href="https://github.com/dkundel/emoji-rating">
            Web Component Code for emoji-rating
          </a>
        </li>
        <li>
          <a href="https://github.com/dkundel/vote-my-talk-preact">
            Code for this demo
          </a>
        </li>
        <li>
          <a href="https://www.twilio.com/blog/2018/02/creating-and-publishing-web-components-with-stencil.html">
            Creating web components in Stencil
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Resources;



// WEBPACK FOOTER //
// ./src/components/Resources.js